

import {Component, Mixins, Prop} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {IArac, DosyaBorcluEgmCevap} from "@/plugins/uyap-plugin/uyap/DosyaBorcluEgm";
import SorguKaynakRozeti from "@/components/eicrapro/sorgu/SorguKaynakRozeti.vue";

@Component({
  components: {SorguKaynakRozeti}
})

export default class DosyaBorcluEgmPicker extends Mixins(SimpleInputMixin) {
  @Prop({required: true}) dosyaId!: string;
  @Prop({required: true}) kisiKurumId!: number;
  @Prop() rules!: string;
  @Prop() showUyapIcon!: string | boolean;
  @Prop() tooltip!: string;

  items: Array<IArac> = [];
  cevap: DosyaBorcluEgmCevap | null = null;
  yenileniyor = false;

  get isShowUyapIcon() {
    return this.showUyapIcon || this.showUyapIcon === "";
  }

  onAracChange(v: IArac) {
    this.$emit('plakaYildizli', (this.items.find(item => item.plakaSifreli == this.localValue))?.plaka);
    this.input();
  }

  created() {
    this.load();
  }

  async load(fresh = false) {
    const istek = this.$uyap.DosyaBorcluEgm();
    if (fresh)
      istek.fresh();
    const cevap = await istek.run({
      dosyaId: this.dosyaId,
      kisiKurumId: this.kisiKurumId,
      sorguBakiye: '',
      pageIndex: 0
    });
    this.cevap = cevap;
    let items = cevap.sorguSonucDVO?.aracBilgileri.aracList;
    if (items)
      this.items = items;
  }

  async yenile() {
    if (this.yenileniyor) {
      return;
    }
    this.yenileniyor = true;
    try {
      await this.load(true);
    } catch (e: any) {
      this.$toast.error(e.message || "Sorgu yenilenemedi.");
    } finally {
      this.yenileniyor = false;
    }
  }
}
